import * as React from "react";
const SvgFiRrNoteMedical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-note-medical_svg__a)">
      <path
        fill="#062147"
        d="M13 13v3a1 1 0 1 1-2 0v-3H8a1 1 0 1 1 0-2h3V8a1 1 0 1 1 2 0v3h3a1 1 0 1 1 0 2zm11.04-8v9.929a5.97 5.97 0 0 1-1.758 4.243l-3.072 3.07A5.96 5.96 0 0 1 14.967 24H5.04c-2.757 0-5-2.243-5-5V5c0-2.757 2.243-5 5-5h14c2.757 0 5 2.243 5 5m-9 16.999V18c0-1.654 1.345-3 3-3h3.998V5c0-1.654-1.346-3-3-3H5.04c-1.654 0-3 1.346-3 3v14c0 1.654 1.346 3 3 3zm5.828-4.241q.347-.348.595-.758H18.04c-.55 0-1 .448-1 1v3.424q.41-.248.757-.595l3.072-3.07z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-note-medical_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrNoteMedical;
